var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = { class: "position-relative" };
var _hoisted_2 = { class: "select_box" };
var _hoisted_3 = { class: "text-truncate d-flex flex-wrap fs-6.5" };
var _hoisted_4 = {
    key: 0,
    class: "hint"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["id"];
var _hoisted_7 = { class: "filter_search" };
var _hoisted_8 = ["placeholder"];
var _hoisted_9 = {
    key: 1,
    class: "bi bi-search"
};
var _hoisted_10 = { class: "row filterUI-body" };
var _hoisted_11 = { class: "col-4 border-end h-100" };
var _hoisted_12 = { class: "filterUI-body-left list-group list-group-flush filterUI-body-category" };
var _hoisted_13 = ["onClick"];
var _hoisted_14 = { class: "filterUI-body-right col h-100" };
var _hoisted_15 = { class: "row filterUI-body-list" };
var _hoisted_16 = { class: "form-check" };
var _hoisted_17 = ["id", "value"];
var _hoisted_18 = ["for"];
var _hoisted_19 = {
    key: 1,
    class: "filterUI-body-right col h-100"
};
var _hoisted_20 = { class: "row filterUI-body-list" };
var _hoisted_21 = {
    key: 0,
    class: "p-3 text-secondary-200"
};
var _hoisted_22 = { class: "form-check" };
var _hoisted_23 = ["id", "value"];
var _hoisted_24 = ["for"];
var _hoisted_25 = { class: "row filterUI-footer" };
var _hoisted_26 = { class: "result d-flex flex-wrap" };
var _hoisted_27 = ["name", "value"];
var _hoisted_28 = { class: "text-info mx-3" };
var _hoisted_29 = ["onClick"];
var _hoisted_30 = { class: "btns d-flex justify-content-end px-4 py-3" };
var _hoisted_31 = { class: "d-flex align-items-end" };
import { ref, watch, computed, nextTick } from 'vue';
// Props 정의
export default /*@__PURE__*/ _defineComponent({
    __name: 'TwoDepthFilter',
    props: {
        options: {
            required: true,
            type: (Array),
        },
        initValue: {
            required: false,
            type: (Array),
            default: function () { return []; },
        },
        type: {
            required: true,
            type: String,
        },
        filterVisible: {
            required: true,
            type: Boolean,
        },
        locales: {
            required: true,
            type: Object,
        },
    },
    emits: ['filter-toggle-event', 'update:init-value'],
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        // Emits 정의
        var emit = __emit;
        // Reactive 데이터
        var lang = ref(document.documentElement.lang);
        var selectedCategory = ref(null);
        var selectedSkills = ref([]);
        var skills = ref([]);
        var displayForDyslexic = ref(true);
        var searchQuery = ref('');
        var searchInputRef = ref(null);
        var isComposing = ref(false);
        // Methods
        // 검색 결과 계산
        var filteredSkills = computed(function () {
            if (!searchQuery.value.trim())
                return [];
            var query = searchQuery.value.toLowerCase();
            var allSkills = props.options.flatMap(function (opt) { return opt.children || []; });
            // 초성 검색 여부 확인
            var isInitialSearch = isKoreanInitial(query);
            return allSkills.filter(function (skill) {
                var _a;
                var label = ((_a = skill["lang_".concat(lang.value)]) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
                if (isInitialSearch) {
                    // 옵션의 초성을 추출해서 검색어와 비교
                    var initials = extractInitials(label.toLowerCase());
                    return initials.startsWith(query);
                }
                else {
                    // 일반 검색 (부분 일치)
                    return label.includes(query);
                }
            });
        });
        var syncSelectedSkills = function (newInitValue) {
            var allSkills = props.options.flatMap(function (option) {
                return option.children ? option.children : [];
            });
            if (Array.isArray(newInitValue)) {
                selectedSkills.value = allSkills.filter(function (option) {
                    return newInitValue.includes(option.code);
                });
            }
            else if (typeof newInitValue === 'string') {
                var selectedOption = allSkills.find(function (option) { return option.code === newInitValue; });
                selectedSkills.value = selectedOption ? [selectedOption] : [];
            }
            else {
                selectedSkills.value = [];
            }
        };
        var updateInitValue = function (newSelectedSkills) {
            var selectedCodes = (newSelectedSkills !== null && newSelectedSkills !== void 0 ? newSelectedSkills : []).map(function (category) { return category.code; });
            emit('update:init-value', selectedCodes);
        };
        var toggleFilterPopup = function () {
            emit('filter-toggle-event', props.type, !props.filterVisible);
        };
        var closeFilterPopup = function () {
            emit('filter-toggle-event', props.type, false);
        };
        var removeSelectedSkill = function (code) {
            selectedSkills.value = selectedSkills.value.filter(function (selected) { return selected.code !== code.code; });
        };
        var resetFilter = function () {
            selectedSkills.value = [];
            selectedCategory.value = null;
            displayForDyslexic.value = true;
        };
        // props.options가 바뀌면 optionsLocal도 동기화
        watch(function () { return props.options; }, function (newVal) {
            if (!selectedCategory.value) {
                skills.value = [];
            }
        });
        var selectCategory = function (category) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                selectedCategory.value = category;
                displayForDyslexic.value = false;
                if (category.children && category.children.length > 0) {
                    skills.value = __spreadArray([], category.children, true);
                }
                else {
                    skills.value = [];
                }
                return [2 /*return*/];
            });
        }); };
        // Watchers
        watch(function () { return props.initValue; }, function (newVal) {
            var currentCodes = selectedSkills.value.map(function (s) { return s.code; });
            if (JSON.stringify(currentCodes) !== JSON.stringify(newVal)) {
                syncSelectedSkills(newVal);
            }
        }, { immediate: true });
        var isFirstSync = true;
        watch(selectedSkills, function (newSelectedSkills) {
            if (isFirstSync) {
                isFirstSync = false;
                return; // 최초 동기화에서는 emit 안 함
            }
            updateInitValue(newSelectedSkills);
        }, { deep: true });
        watch(function () { return props.filterVisible; }, function (visible) {
            if (visible) {
                nextTick(function () {
                    var _a;
                    (_a = searchInputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
                });
            }
            else {
                searchQuery.value = '';
            }
        });
        var previousSearchQuery = "";
        var onKeyup = function (event) {
            var currentQuery = event.target.value;
            // 검색어가 변경되었는지 확인
            if (currentQuery !== previousSearchQuery) {
                previousSearchQuery = currentQuery;
            }
            searchQuery.value = currentQuery;
        };
        // 한글 입력 완료 시 발생
        var handleCompositionEnd = function (event) {
            isComposing.value = false;
            searchQuery.value = event.target.value;
        };
        // 한글 초성 추출 함수
        var extractInitials = function (str) {
            var initialConsonants = [
                'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'
            ];
            return str.split('').map(function (char) {
                var code = char.charCodeAt(0) - 44032;
                // 한글이 아닌 경우 그대로 반환
                if (code < 0 || code > 11171) {
                    return char;
                }
                return initialConsonants[Math.floor(code / 588)];
            }).join('');
        };
        var isKoreanInitial = function (str) {
            return /^[ㄱ-ㅎ]+$/.test(str); // 초성만 있는지 확인
        };
        var clearSearch = function () {
            searchQuery.value = '';
            nextTick(function () {
                var _a;
                (_a = searchInputRef.value) === null || _a === void 0 ? void 0 : _a.focus();
            });
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "dropdown-toggle position-relative",
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (toggleFilterPopup()); })
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            (selectedSkills.value.length === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.type === 'skill' ? __props.locales.mypage_cv_s3_skillcode_ph : ''), 1))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(selectedSkills.value, function (code) {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: 'title_' + code.code,
                                        class: "selected_code"
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(code['lang_' + lang.value]), 1),
                                        _createElementVNode("button", {
                                            class: "btn btn-sm",
                                            type: "button",
                                            "aria-label": "Close",
                                            onClick: _withModifiers(function ($event) { return (removeSelectedSkill(code)); }, ["stop", "prevent"])
                                        }, _cache[9] || (_cache[9] = [
                                            _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
                                        ]), 8, _hoisted_5)
                                    ]));
                                }), 128))
                        ]),
                        _cache[10] || (_cache[10] = _createElementVNode("button", { type: "button" }, [
                            _createElementVNode("i", { class: "bi bi-chevron-down" })
                        ], -1))
                    ])
                ]),
                _withDirectives(_createElementVNode("div", {
                    class: "filterUI",
                    id: __props.type + 'Filter'
                }, [
                    _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                            ref_key: "searchInputRef",
                            ref: searchInputRef,
                            type: "search",
                            onKeyup: onKeyup,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((searchQuery).value = $event); }),
                            onCompositionstart: _cache[2] || (_cache[2] = function ($event) { return (isComposing.value = true); }),
                            onCompositionend: handleCompositionEnd,
                            placeholder: __props.locales.common_search_ph
                        }, null, 40, _hoisted_8), [
                            [_vModelText, searchQuery.value]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                            type: "hidden",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((searchQuery).value = $event); })
                        }, null, 512), [
                            [_vModelText, searchQuery.value]
                        ]),
                        (searchQuery.value.trim())
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: "bi bi-x-lg",
                                onClick: _withModifiers(clearSearch, ["stop", "prevent"])
                            }))
                            : (_openBlock(), _createElementBlock("i", _hoisted_9))
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        (!searchQuery.value.trim())
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["list-group-item list-group-item-action", displayForDyslexic.value ? 'select' : '']),
                                            type: "button",
                                            onClick: _cache[4] || (_cache[4] = function ($event) { return (resetFilter()); })
                                        }, [
                                            _createElementVNode("span", null, _toDisplayString(__props.locales.common_all), 1)
                                        ], 2),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, function (category) {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: category.code,
                                                class: _normalizeClass(["list-group-item list-group-item-action", { active: selectedCategory.value && selectedCategory.value.code == category.code }]),
                                                type: "button",
                                                onClick: function ($event) { return (selectCategory(category)); }
                                            }, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass({ select: selectedSkills.value.some(function (skill) { return skill.code.startsWith(category.code); }) })
                                                }, _toDisplayString(category['lang_' + lang.value]), 3),
                                                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-chevron-right" }, null, -1))
                                            ], 10, _hoisted_13));
                                        }), 128))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _withDirectives(_createElementVNode("div", { class: "filterUI-body-list-item w-100 text-secondary-200" }, _toDisplayString(__props.locales.recruit_filter_select), 513), [
                                            [_vShow, !displayForDyslexic.value && !selectedCategory.value]
                                        ]),
                                        _withDirectives(_createElementVNode("div", { class: "filterUI-body-list-item w-100 text-secondary-200" }, _toDisplayString(__props.locales.recruit_filter_all), 513), [
                                            [_vShow, displayForDyslexic.value]
                                        ]),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skills.value, function (skill) {
                                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                                                class: "filterUI-body-list-item",
                                                key: skill.code
                                            }, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        id: skill.code,
                                                        type: "checkbox",
                                                        value: skill,
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((selectedSkills).value = $event); })
                                                    }, null, 8, _hoisted_17), [
                                                        [_vModelCheckbox, selectedSkills.value]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: skill.code
                                                    }, _toDisplayString(skill['lang_' + lang.value]), 9, _hoisted_18)
                                                ])
                                            ])), [
                                                [_vShow, selectedCategory.value]
                                            ]);
                                        }), 128))
                                    ])
                                ])
                            ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                    (filteredSkills.value.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(__props.locales.common_noresult), 1))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredSkills.value, function (skill) {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: skill.code,
                                                class: "filterUI-body-list-item"
                                            }, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        id: skill.code,
                                                        type: "checkbox",
                                                        value: skill,
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((selectedSkills).value = $event); })
                                                    }, null, 8, _hoisted_23), [
                                                        [_vModelCheckbox, selectedSkills.value]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        class: "form-check-label",
                                                        for: skill.code
                                                    }, _toDisplayString(skill['lang_' + lang.value]), 9, _hoisted_24)
                                                ])
                                            ]));
                                        }), 128))
                                ])
                            ]))
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSkills.value, function (code) {
                                return (_openBlock(), _createElementBlock("input", {
                                    key: 'hidden_' + code.code,
                                    type: "hidden",
                                    name: "".concat(__props.type, "[]"),
                                    value: code.code
                                }, null, 8, _hoisted_27));
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedSkills.value, function (code) {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: 'selected_' + code.code,
                                    class: "d-flex align-items-center"
                                }, [
                                    (selectedSkills.value.length > 0)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("span", _hoisted_28, _toDisplayString(code['lang_' + lang.value]), 1),
                                            _createElementVNode("button", {
                                                class: "btn-close btn btn-sm",
                                                type: "button",
                                                "aria-label": "Close",
                                                onClick: _withModifiers(function ($event) { return (removeSelectedSkill(code)); }, ["stop", "prevent"])
                                            }, _cache[12] || (_cache[12] = [
                                                _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
                                            ]), 8, _hoisted_29)
                                        ], 64))
                                        : _createCommentVNode("", true)
                                ]));
                            }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("button", {
                                    class: "btn btn-sm py-0",
                                    type: "button",
                                    onClick: _cache[7] || (_cache[7] = function ($event) { return (resetFilter()); })
                                }, [
                                    _createTextVNode(_toDisplayString(__props.locales.common_reset), 1),
                                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-arrow-counterclockwise" }, null, -1))
                                ])
                            ]),
                            _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] = function ($event) { return (closeFilterPopup()); }),
                                class: "btn btn-primary text-white",
                                type: "button"
                            }, _toDisplayString(__props.locales.common_set), 1)
                        ])
                    ])
                ], 8, _hoisted_6), [
                    [_vShow, __props.filterVisible]
                ])
            ]));
        };
    }
});
